import ArFilterCombobox from "../../ui/combo-box/FilterComboBox";
import FindAllSupplier from "@/v2/api/supplier/FindAll";
import FindAllMobilizationSupplierOptions, {
    SupplierOption,
} from "@/v2/api/supplier/FindAllMobilizationOptions";

interface SupplierFilterComboBoxProps {
    value?: string; // The selected employee ID
    onChange?: (employeeId: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    label?: string;
    // "mobilization" lists all records regardless of assignment (mobilization filters only)
    source?: "default" | "mobilization";
}

export default function SupplierFilterComboBox({
    value,
    onChange,
    placeholder = "Select supplier...",
    disabled = false,
    className,
    label = "Supplier",
    source = "default",
}: SupplierFilterComboBoxProps) {
    const handleSelect = (item: SupplierOption | null) => {
        if (onChange) {
            onChange(item ? item.id : "");
        }
    };

    const renderEmployeeItem = (supplier: SupplierOption) => (
        <div className="flex flex-col">
            <span>{supplier.full_name}</span>
            {supplier.short_code && (
                <span className="text-xs text-muted-foreground">
                    {supplier.short_code}
                </span>
            )}
        </div>
    );

    return (
        <ArFilterCombobox<SupplierOption>
            label={label}
            labelAlign="items-start"
            queryKey={
                source === "mobilization"
                    ? ["mobilization-supplier-options"]
                    : ["supplier"]
            }
            queryFn={async ({ pageParam, search, limit }) =>
                (source === "mobilization"
                    ? FindAllMobilizationSupplierOptions
                    : FindAllSupplier)({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            getDisplayValue={(supplier: SupplierOption) => supplier.full_name}
            renderItem={renderEmployeeItem}
            placeholder={placeholder}
            searchPlaceholder="Search supplier..."
            className={className}
            disabled={disabled}
            onItemSelect={handleSelect}
            defaultValueId={value}
            pageSize={20}
            debounceMs={300}
        />
    );
}
